import { type IStage, movSitesV2 } from '@metservicedev/platforms-services-interface/src';
import type { ISiteCreateEventBody } from '@metservicedev/platforms-services-interface/src/services/movSites/MovSitesV2Model';

const createSite = async (data: ISiteCreateEventBody, stage: IStage, metJwt: string, headers: any) => {
    try {
        // NEW service
        const res = await movSitesV2.http.create({
            token: metJwt,
            stage: stage,
            body: {
                ...data,
            },
            headers,
        });

        return res.data;
    } catch (err) {
        console.error(err);
    }
};

export default createSite;
